import { usePrevious } from "@react-hookz/web";
import { debounce, filter } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { TfiLayoutGrid4, TfiLayoutSidebar2 } from "react-icons/tfi";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Redirect,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { Box, Flex } from "rebass";
import { LoadingFrame } from "../components/common/LoadingFrame";
import CatalogueCount from "../components/order/CatalogueCount";
import CatalogueNavigation from "../components/order/CatalogueNavigation";
import { Product } from "../components/product";
import useCatalogueFilters from "../hooks/useCatalogueFilters";
import useFiltersAndSearchMobile from "../hooks/useFiltersAndSearchMobile";
import useGuardCustomerRoute from "../hooks/useGuardCustomerRoute";
import useOrderType from "../hooks/useOrderType";
import useResponsive from "../hooks/useResponsive";
import { MainLayout } from "../layouts/MainLayout";
import {
  systemActions,
  yodaCatalogueActions,
  yodaCustomerActions,
  yodaIdentityActions,
  yodaMessageActions,
  yodaOrdersActions,
} from "../logic/actions";
import { getLocalizedString } from "../utils";
import config from "../utils/globalConfig";

const CataloguePageNew = () => {
  const dispatch = useDispatch();
  const { orderId } = useParams();
  const history = useHistory();

  const catalogueRefs = useRef({});

  const {
    calculateAllFilter,
    toggleFilterMobile,
    openFilterMobile,
    removeFilter,
    removeAllFilters,
    colorTextFilter,
    selectSizeFilter,
    selectColorFilter,
    selectCollectionFilter,
    selectContinuousFilter,
    selectCategoryFilter,
    selectProductTypeFilter,
    selectFittingFilter,
    colorFilterValues,
    sizeFilterValues,
    productTypeFilterValues,
    categoryFilterValues,
    collectionFilterValues,
    continuousFilterValues,
    fittingFilterValues,
    closureFilterValues,
    hoodFilterValues,
    paddingFilterValues,
    pocketsFilterValues,
    reversibleFilterValues,
    sleevesFilterValues,
    colorFilterFiltered,
    allFilterValue,
    searchText,
    setColorFilterFiltered,
    setSearchText,
    hasFilters,
    openFilters,
    toggleFilter,
    selectClosureFilter,
    selectHoodFilter,
    selectPaddingFilter,
    selectPocketsFilter,
    selectReversibleFilter,
    selectSleevesFilter,
  } = useCatalogueFilters();

  const {
    catalogue,
    totalCount,
    collectionFilterList,
    continuousFilterList,
    categoryFilterList,
    productTypeFilterList,
    colorFilterList,
    sizeFilterList,
    fittingFilterList,
    closureFilterList,
    hoodFilterList,
    paddingFilterList,
    pocketsFilterList,
    reversibleFilterList,
    sleevesFilterList,
  } = useSelector((state) => state.yodaCatalogue);

  const { offsetTop, minimizedUi, mobileMinicartOpen } = useSelector(
    (state) => state.system,
  );

  const { customer } = useSelector((state) => state.yodaCustomer);

  const { currentPage, totalPages, loadingNext } = useSelector(
    (state) => state.yodaCatalogue,
  );
  const { catalogueSelected, tab } = useSelector((state) => state.system);
  const { colors } = useSelector((state) => state.yodaIdentity);
  const {
    order,
    orderRowDetails,
    statusCode,
    error,
    totalReorder,
    totalSwap,
    maxSwap,
  } = useSelector((state) => state.yodaOrders);
  const { budget } = useSelector((state) => state.yodaBudget);
  const { me } = useSelector((state) => state.yodaStakeholders);

  const { isMobile, breakpoint } = useResponsive();

  const filterProps = useFiltersAndSearchMobile();

  const [orderType, setOrderType] = useState(0);
  const [showStatusView, setShowStatusView] = useState(false);
  const [seasonCodeP, setSeasonCodeP] = useState(0);
  const [flagColor, setFlagColor] = useState("green");
  const [catalogueRequestNext, setCatalogueRequestNext] = useState(false);
  const [nextPageInLoading, setNextPageInLoading] = useState(false);
  const [fistIngressCatalogue, setFistIngressCatalogue] = useState(true);
  const [allScreen, setAllScreen] = useState(false);

  const { isSwapEnabledForOrder } = useOrderType();

  const inputSearchRef = useRef();

  const disableScroll =
    !!mobileMinicartOpen || !!catalogueSelected || !!showStatusView;

  useGuardCustomerRoute({ matchOrder: true });

  useEffect(() => {
    return () => {
      dispatch(yodaOrdersActions.resetOldOrder());
    };
  }, []);

  useEffect(() => {
    dispatch(
      yodaMessageActions.getMessages(localStorage.getItem("selectedCustomer")),
    );

    return () => {
      dispatch(yodaMessageActions.clearMessages());
    };
  }, []);

  useEffect(() => {
    return () => {
      dispatch(systemActions.closeCatalogueItem());
      dispatch(systemActions.setTab(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const type = orderType == config.ORDER_TYPE_SWAP ? 1 : 0;
    if (orderType && tab === null) dispatch(systemActions.setTab(type));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderType, tab]);

  useEffect(() => {
    if (colorFilterList?.length) setColorFilterFiltered(colorFilterList);
  }, [colorFilterList]);

  useEffect(() => {
    setFistIngressCatalogue(false);
  }, []);

  function handleKeyPress(event) {
    if (event.keyCode == 9) {
      event.preventDefault();
      let focusedPadIndex = -1;
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads?.length; ++index) {
        if (numericPads[index].style.display == "block") {
          focusedPadIndex = index;
        }
      }
      let i = (focusedPadIndex + 1) % numericPads?.length;
      if (numericPads[i] !== undefined) {
        numericPads[i].click();
      }
    }
    if (event.key == "Enter") {
      event.preventDefault();
      let numericPads = document.querySelectorAll(".editable.numericPadInput");
      for (let index = 0; index < numericPads?.length; ++index) {
        if (numericPads[index].style.display == "block") {
          numericPads[index].blur();
        }
      }
    }
    if (event.keyCode === 187) {
      event.preventDefault();
      let el = document.querySelector(".valueUp");
      if (el) {
        el.click();
      }
    }
    if (event.keyCode === 189) {
      event.preventDefault();
      let el = document.querySelector(".valueDown");
      if (el) {
        el.click();
      }
    }
  }

  const handleMobileDetailClose = (productId) => {
    setTimeout(() => {
      catalogueRefs?.current?.[productId]?.scrollIntoView?.({ block: "end" });
    });
  };

  const handleRemove = (value) => {
    removeFilter(value);
    if (inputSearchRef.current && value.startsWith("search_"))
      inputSearchRef.current.value = "";
  };

  const handleRemoveAll = () => {
    removeAllFilters();
    if (inputSearchRef.current) inputSearchRef.current.value = "";
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const isWindowScrolledToBottom = useCallback(
    debounce((event, disableScroll) => {
      if (event.cancelable) event.preventDefault();
      if (document && window) {
        const scrollableHeight = Math.round(
          document.documentElement.scrollHeight - window.innerHeight,
        );
        const bottom =
          window.scrollY >= scrollableHeight - 1 &&
          window.scrollY <= scrollableHeight + 1;
        if (bottom && !disableScroll) {
          setCatalogueRequestNext(true);
        }
      }
    }, 600),
    [],
  );

  useEffect(() => {
    dispatch(yodaOrdersActions.orderReset(null));
    if (window) {
      window.addEventListener("keydown", handleKeyPress);
    }
    if (document) {
      setTimeout(() => {
        document
          .getElementById("scrollContainer")
          ?.addEventListener?.("scroll", isInViewport);
      }, 1000);
      document.externalPinPadHandle = {};
    }
    return () => {
      if (window) {
        window.removeEventListener("keydown", handleKeyPress);
      }
      if (document) {
        const scroll = document.getElementById("scrollContainer");
        if (scroll) {
          scroll.removeEventListener("scroll", isInViewport);
        }
        document.externalPinPadHandle = undefined;
        document.orderTypeId = undefined;
        document.swapRowExist = undefined;
        document.orderRowDetails = undefined;
      }
    };
  }, []);

  useEffect(() => {
    if (document) {
      document.body.addEventListener("touchmove", (e) =>
        isWindowScrolledToBottom(e, disableScroll),
      );
    }
    return () => {
      if (document) {
        document.body.removeEventListener("touchmove", (e) =>
          isWindowScrolledToBottom(e, disableScroll),
        );
      }
    };
  }, [disableScroll, isWindowScrolledToBottom]);

  useEffect(() => {
    if (orderId) {
      dispatch(yodaOrdersActions.getOrderById(orderId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  useEffect(() => {
    if (order && tab !== null) {
      let seasonCode = order.seasonId;
      let lineCode = order?.customData?.lineId;

      if (document) {
        document.orderTypeId = order.orderTypeId;
      }
      setSeasonCodeP(seasonCode);

      if (!fistIngressCatalogue) {
        handleRemoveAll();
        dispatch(yodaCatalogueActions.clearOrderCatalog());
        dispatch(
          yodaCatalogueActions.getAll({
            searchText,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
          }),
        );
      }

      dispatch(systemActions.expandCatalogueItem(0));
      dispatch(yodaCustomerActions.getOne(order.stakeholderId));
    }
  }, [fistIngressCatalogue, order, tab]);

  useEffect(() => {
    dispatch(yodaIdentityActions.getColors());
    dispatch(yodaOrdersActions.orderIdReset());
    dispatch(yodaOrdersActions.getOrderDetails(orderId));
    dispatch(
      yodaOrdersActions.getOrderConfiguration(
        localStorage.getItem("selectedCustomer"),
      ),
    );
  }, []);

  useEffect(() => {
    if (
      catalogueRequestNext &&
      currentPage + 1 <= totalPages &&
      !nextPageInLoading
    ) {
      let seasonCode = order?.seasonId;
      let lineCode = order?.customData?.lineId;

      dispatch(
        yodaCatalogueActions.addAll({
          searchText,
          page: currentPage + 1,
          pageSize: config.PAGE_SIZE,
          seasonId: seasonCode,
          lineId: lineCode,
          customerId: order.stakeholderId,
          collectionIds: collectionFilterValues,
          continuousIds: continuousFilterValues,
          categoryIds: categoryFilterValues,
          subcategoryIds: productTypeFilterValues,
          colorIds: colorFilterValues,
          sizeIds: sizeFilterValues,
          fittingIds: fittingFilterValues,
          closureIds: closureFilterValues,
          hoodIds: hoodFilterValues,
          paddingIds: paddingFilterValues,
          pocketsIds: pocketsFilterValues,
          reversibleIds: reversibleFilterValues,
          sleevesIds: sleevesFilterValues,
        }),
      );
      setNextPageInLoading(true);
    }
  }, [catalogueRequestNext]);

  useEffect(() => {
    if (currentPage == 1) {
      setNextPageInLoading(false);
      setCatalogueRequestNext(false);
    }
  }, [currentPage]);

  useEffect(() => {
    setNextPageInLoading(false);
    setCatalogueRequestNext(false);
    document
      .getElementById("scrollContainer")
      ?.scrollTo({ top: 0, behavior: "smooth" });
  }, [tab]);

  useEffect(() => {
    if (!loadingNext && nextPageInLoading) {
      setNextPageInLoading(false);
      setCatalogueRequestNext(false);
    }
  }, [loadingNext]);

  const previousAllFilterValue = usePrevious(allFilterValue);
  useEffect(() => {
    const currSearch = allFilterValue?.find(
      (filter) => filter?.type === "search_",
    );
    const prevSearch = previousAllFilterValue?.find(
      (filter) => filter?.type === "search_",
    );
    if (
      (allFilterValue?.length !== previousAllFilterValue?.length ||
        currSearch?.text !== prevSearch?.text) &&
      order &&
      tab !== null
    ) {
      let seasonCode = order.seasonId;
      let lineCode = order.customData?.lineId;

      if (tab === 0) {
        dispatch(
          yodaCatalogueActions.getAll({
            searchText,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );

        dispatch(systemActions.expandCatalogueItem(0));
      } else if (tab == 1) {
        dispatch(
          yodaCatalogueActions.getAllSwap({
            searchText,
            seasonId: seasonCode,
            lineId: lineCode,
            customerId: order.stakeholderId,
            collectionIds: collectionFilterValues,
            continuousIds: continuousFilterValues,
            categoryIds: categoryFilterValues,
            subcategoryIds: productTypeFilterValues,
            colorIds: colorFilterValues,
            sizeIds: sizeFilterValues,
            fittingIds: fittingFilterValues,
            closureIds: closureFilterValues,
            hoodIds: hoodFilterValues,
            paddingIds: paddingFilterValues,
            pocketsIds: pocketsFilterValues,
            reversibleIds: reversibleFilterValues,
            sleevesIds: sleevesFilterValues,
          }),
        );

        dispatch(systemActions.expandCatalogueItem(0));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFilterValue, previousAllFilterValue]);

  function isInViewport() {
    if (!isMobile) {
      const rect = document
        .getElementById("checkForNext")
        ?.getBoundingClientRect();
      let check = false;
      if (rect) {
        check =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth);
      }

      setCatalogueRequestNext(!!check);
    }
  }

  useEffect(() => {
    document.swapRowExist =
      filter(
        orderRowDetails,
        (k, v) => k.customData.typeId == config.ORDER_TYPE_SWAP,
      ).length > 0;
    document.orderRowDetails = { ...orderRowDetails };
  }, [orderRowDetails]);

  function selectTextFilter(event) {
    if (event.keyCode === 13) {
      if (inputSearchRef.current) inputSearchRef.current.value = "";
      changeQueryClick();
      filterProps.setOpenSearch(false);
      return;
    }
    let value = event.target.value;
    setSearchText(value);
  }

  function handlePasteSearch(event) {
    setSearchText(event.clipboardData.getData("Text"));
  }

  function sendBtn() {
    if (inputSearchRef.current) inputSearchRef.current.value = "";
    changeQueryClick();
    filterProps.setOpenSearch(false);
  }

  const resetScroll = () => {
    if (window) window.scrollTo(0, 0);
    const scrollContainer = document?.getElementById("scrollContainer");
    if (scrollContainer) scrollContainer.scrollTo(0, 0);
  };

  function changeQueryClick() {
    calculateAllFilter();
    resetScroll();
  }

  function reorderCatalogue(array) {
    let tmpArray = [];
    const gridColumnCount = breakpoint([2, 2, 3]);
    for (let i = 0; i < array?.length; i += gridColumnCount) {
      let tmpSubArray = [];
      let chunk = array.slice(i, i + gridColumnCount);

      let chuckExpanded = chunk.filter((e) => e.productId == catalogueSelected);
      let chuckNotExpanded = chunk.filter(
        (e) => e.productId != catalogueSelected,
      );

      tmpSubArray = [...chuckExpanded, ...chuckNotExpanded];
      if (chuckExpanded.length > 0) {
        tmpArray = [...tmpArray, tmpSubArray];
      } else {
        tmpArray = [...tmpArray, tmpSubArray];
      }
    }
    return tmpArray.flat();
  }

  useEffect(() => {
    let color = "";
    if (statusCode == 2) color = "green";
    if (statusCode == 1) color = "yellow";
    if (statusCode == 0) color = "red";
    setFlagColor(color);
  }, [statusCode]);

  useEffect(() => {
    if (order) {
      setOrderType(order.orderTypeId);
    }
  }, [order]);

  if (me?.error === "not-authorized") {
    return (
      <Redirect
        to={{
          pathname: "/not-authorized",
          state: {
            yodaError: true,
          },
        }}
      />
    );
  }
  return (
    <MainLayout viewportAll={allScreen}>
      <LoadingFrame
        catalog
        order={!!catalogue && !!me && !!customer}
      ></LoadingFrame>
      <Box sx={{ width: "100%", position: ["unset", "relative"] }}>
        <Flex
          width={1}
          pb={3}
          px={["10px", "10px", "10px"]}
          mb={"20px"}
          sx={{
            position: "relative",
            ...(isMobile &&
              disableScroll && {
                overflow: "hidden",
                height: 0,
              }),
          }}
        >
          <Flex
            width={[1, 1, 1]}
            height={"auto"}
            paddingTop={isMobile ? 3 : 0}
            sx={{ flexDirection: "column" }}
          >
            <Box
              height={"auto"}
              width={"100%"}
              alignSelf={"center"}
              pb={"10px"}
              display={["none", "none", "block"]}
              sx={{
                position: "sticky",
                backgroundColor: "#fff",
                zIndex: 2,
              }}
            >
              <Flex
                w={1}
                flexDirection={["column", "column", "row"]}
                justifyContent={"space-between"}
                alignItems={"center"}
                minHeight={"72px"}
              >
                <CatalogueCount {...{ catalogue, totalCount }} />
                <Box
                  height={"fit-content"}
                  width={"fit-content"}
                  sx={{
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setAllScreen(!allScreen);
                  }}
                >
                  {allScreen && <TfiLayoutSidebar2 size={24} />}
                  {!allScreen && <TfiLayoutGrid4 size={24} />}
                </Box>
              </Flex>
            </Box>
            {catalogue?.length === 0 && (
              <Flex
                style={{
                  height: "150px",
                  display: "grid",
                  justifyContent: "center",
                  alignContent: "center",
                  marginLeft: "30px",
                }}
                justifyContent={"center"}
                mb={4}
                fontSize={12}
              >
                {getLocalizedString("CATALOGUE IS EMPTY")}
              </Flex>
            )}

            <Box
              id="gridContainer"
              sx={{
                display: "grid",
                gridGap: ["10px", null, 3],
                gridTemplateColumns: [
                  "repeat(2, 1fr)",
                  "repeat(3, 1fr)",
                  "repeat(auto-fit, minmax(240px, 1fr))",
                ],
                justifyContent: "center",
                transition: "300ms",
                position: "relative",
                alignItems: "baseline",
              }}
              // onWheel={scrollHandle}
            >
              {catalogue?.length > 0 &&
                reorderCatalogue(catalogue)?.map((item, index) => {
                  const expanded = catalogueSelected == item.productId;
                  return (
                    <Box
                      key={`catalogue-item-${index}-${item.productId}`}
                      ref={(el) => (catalogueRefs.current[item.productId] = el)}
                      {...(!isMobile &&
                        expanded && {
                          sx: { gridColumn: "1 / -1" },
                        })}
                    >
                      <Product
                        id={item.productId}
                        images={item.catalog}
                        swap={false}
                        catalog={item?.catalog}
                        seasonCode={seasonCodeP}
                        modelCode={item.modelCode}
                        articleCode={item.materialCode}
                        colorCodes={item.color}
                        lineCode={item.lineCode}
                        collectionCode={item.collectionCode}
                        collectionDescription={item.collectionDescription}
                        seasonDescription={item.seasonDescription}
                        modelDescription={item.modelDescription}
                        materialCode={item.materialCode}
                        materialDescription={item.materialDescription}
                        materialComposition={item.materialComposition}
                        categoryCode={item.categoryCode}
                        categoryDescription={item.categoryDescription}
                        subcategoryCode={item.subcategoryCode}
                        subcategoryDescription={item.subcategoryDescription}
                        sizes={item.sizes}
                        color={item.color}
                        shape={item.shape}
                        padding={item.padding}
                        fit={item.fit}
                        tag={item.tag}
                        sleevs={item.sleevs}
                        closure={item.closure}
                        hood={item.hood}
                        pockets={item.pockets}
                        sku={item.sku}
                        madeIn={item.madeIn}
                        prices={item.price}
                        continuous={item.continuous}
                        reversible={item.reversible}
                        imagedefault={item.imagedefault}
                        rotationdefault={item.rotationdefault}
                        checkForNext={
                          index == catalogue.length - 1 ? true : false
                        }
                        {...(!isMobile && { expanded })}
                      />
                    </Box>
                  );
                })}
            </Box>
            <CatalogueNavigation
              sx={{ marginTop: "20px" }}
              onLoadMore={() => setCatalogueRequestNext(true)}
              onGoToTop={resetScroll}
              {...{ catalogue, currentPage, totalPages }}
            />
          </Flex>
        </Flex>
      </Box>
    </MainLayout>
  );
};

export { CataloguePageNew };
